module.exports = __webpack_public_path__ + "static/media/mulher-selos.6b6e563f.png";